import { render, staticRenderFns } from "./ReplacementSummary.vue?vue&type=template&id=276c63ba&"
import script from "./ReplacementSummary.vue?vue&type=script&lang=js&"
export * from "./ReplacementSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276c63ba')) {
      api.createRecord('276c63ba', component.options)
    } else {
      api.reload('276c63ba', component.options)
    }
    module.hot.accept("./ReplacementSummary.vue?vue&type=template&id=276c63ba&", function () {
      api.rerender('276c63ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ReplacementSummary.vue"
export default component.exports